/**
 * Constants for PolicyCanvas component
 */

import { BackgroundVariant } from 'react-flow-renderer';

/**
 * React Flow configuration constants
 */
export const REACT_FLOW_CONFIG = {
  DEFAULT_ZOOM: 1,
  MAX_ZOOM: 1,
  MIN_ZOOM: 1,
  FIT_VIEW: false,
  NODES_CONNECTABLE: false,
  NODES_DRAGGABLE: false,
  ELEMENTS_SELECTABLE: false,
  PAN_ON_DRAG: false,
  PAN_ON_SCROLL: false,
  ZOOM_ON_SCROLL: false,
  ZOOM_ON_PINCH: false,
  ZOOM_ON_DOUBLE_CLICK: false,
  PREVENT_SCROLLING: false,
} as const;

/**
 * Background configuration
 */
export const BACKGROUND_CONFIG = {
  VARIANT: BackgroundVariant.Dots,
  GAP: 20,
  SIZE: 1,
  COLOR: '#e2e8f0',
  OPACITY: 0.4,
} as const;

/**
 * Highlighting styles for upstream path
 */
export const UPSTREAM_HIGHLIGHT_STYLE = {
  stroke: '#3b82f6',
  strokeWidth: 2,
  zIndex: 9999, // Highest z-index for highlighted edges
} as const;

